<template>
  <button :style="`font-size: ${size};`" class="cta-button">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    size: {
      type: String
    }
  }
}
</script>

<style lang="scss">
.cta-button {
  cursor: pointer;
  border: none;
  outline: none;
  background-color: transparent;
  color: rgb(15, 114, 187);
  font-weight: 700;
  font-size: 4rem;
  text-decoration: underline;
  padding: 30px 0;
}
</style>
